
<template>
  <div class="padded">
    <equip-table
    title="Billable Equipment"
    title-heading="h4"
    :site-id="this.siteId"
    :owner-id="this.ownerId"
    :site-data="siteData"
    :show-qr-code="showQrCode"
    filter-col="isBillable"
    filter-val="true" />
  </div>
</template>

<script>

import EquipTable from '@/components/assets/EquipTable'

export default {

  components: {
    EquipTable
  },

  props: {
    siteId: {
      type: Number,
      required: true
    },

    siteData: {
      type: Object
    },

    ownerId: {
      type: Number,
      default: null
    },

    showQrCode: {
      type: Boolean,
      default: false
    }

  }

}

</script>
